export default "__VITE_ASSET__B7ZejVy2__"